"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highestEdition = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _Editions = require("self-service-api/constants/Editions");

var highestEdition = function highestEdition() {
  var editionOrder = [_Editions.FREE, _Editions.STARTER, _Editions.PROFESSIONAL, _Editions.ENTERPRISE];

  for (var _len = arguments.length, editions = new Array(_len), _key = 0; _key < _len; _key++) {
    editions[_key] = arguments[_key];
  }

  return editionOrder[Math.max.apply(Math, (0, _toConsumableArray2.default)(editions.map(function (edition) {
    return editionOrder.indexOf(edition);
  })))];
};

exports.highestEdition = highestEdition;


//////////////////
// WEBPACK FOOTER
// ./js/utils/highestEdition.js
// module id = 807
// module chunks = 5 6